<div [formGroup]="filtri">

    <div class="flex flex-column align-items-left mb-5 pt-5">


        <div class="flex align-items-left  mb-5 sm:mb-0">

            <div class="sm:mr-3">
              <span class="p-input-icon-left p-input-icon-right p-float-label">
                  <i class="pi pi-search"></i>
                  <input type="text" id="patternRicerca" class="shadow-4" pInputText formControlName="pattern" />
                  <label for="patternRicerca">Cerca</label>
                  <i class="pi pi-times pr-1" id="clearIcon" (click)="resetBoxRicerca()"></i>
              </span>
            </div>

        </div>

    </div>

    <div class="flex align-items-center justify-content-center sm:justify-content-start mb-5 flex-wrap gap-3">

      <div class="mr-3">
        <p-calendar
            formControlName="dataDa"
            dateFormat="dd/mm/yy"
            inputId="dataDa"
            [iconDisplay]="'input'"
            placeholder="dal"
            [showIcon]="true"
        ></p-calendar>
      </div>

      <div class="mr-3">
        <p-calendar
            formControlName="dataAl"
            dateFormat="dd/mm/yy"
            inputId="dataAl"
            [iconDisplay]="'input'"
            placeholder="al"
            [showIcon]="true"
        ></p-calendar>
      </div>


          <p-button
          class="clearFiltri"
          size="small"
          [outlined]="true"
          icon="pi pi-filter-slash"
          (click)="clearFilters()"
          pTooltip="Pulisci Filtri"
          tooltipPosition="right"
      />



    </div>

</div>



<div class="mb-5">

    <!-- PAGINATOR della tabella -->
    <div class="flex justify-content-start">
      <p-paginator
          [rows]="pageSize"
          [first]="currentPage"
          [rowsPerPageOptions]="[25, 100, 250, 500]"
          (onPageChange)="pageChange($event)"
          [totalRecords]="totaleDati"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} di {totalRecords}"
          [showPageLinks]="false"
      >
      </p-paginator>
    </div>

</div>

<!-- tabella -->
<div>
    <p-table
    #dt
    [value]="lista"
    [rowHover]="true"
    (onLazyLoad)="ordinamento($event)"
    [customSort]="true"
    [lazy]="true"
    [sortField]="orderColumnName"
    [sortOrder]="orderCustom(order)"
    >
    <!-- headers -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="fonte" class="white-space-nowrap">
            Fonte <p-sortIcon field="fonte"></p-sortIcon>
        </th>
        <th pSortableColumn="codiceFiscale" class="white-space-nowrap">
            Codice Fiscale <p-sortIcon field="codiceFiscale"></p-sortIcon>
        </th>
        <th pSortableColumn="importo" class="white-space-nowrap">
            Importo <p-sortIcon field="importo"></p-sortIcon>
        </th>
        <th pSortableColumn="dataPagamento" class="white-space-nowrap">
            Data pagamento <p-sortIcon field="dataPagamento"></p-sortIcon>
        </th>
        <th pSortableColumn="dataRegistrazione" class="white-space-nowrap">
          Data registrazione <p-sortIcon field="dataRegistrazione"></p-sortIcon>
      </th>
        <th pSortableColumn="dettaglioEsito" class="white-space-nowrap">
          Avvisi <p-sortIcon field="dettaglioEsito"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <!-- rows -->
    <ng-template pTemplate="body" let-item>

        <tr>
            <!--
                id: number;

  username?: string;

  iscrittoId?:number;
  stpId?:number;
  dettaglioEsito?: string;

  : number;

  dataRegistrazione?: string;
             -->
            <td>{{ item.fonte }}</td>

            <td style="cursor: pointer;" [routerLink]="getRoute(item)">{{ item.codiceFiscale }}</td>

            <!-- <td>{{ item.mittente }}</td> -->
            <td>{{ item.importo | number:'1.2-2' }} </td>

            <td>{{ getDataPagamento(item) }}</td>
            <td>{{ getDataRegistrazione(item) }}</td>
            <td>{{ item.dettaglioEsito }}</td>

        </tr>
    </ng-template>
    </p-table>

</div>

<p-toast position="bottom-center"></p-toast>

